<template>
  <v-layout column class="shrink">
    <v-row no-gutters>
      <h2>My Contexts</h2>
      <v-spacer></v-spacer>
      <!-- <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn text color="primary" v-on="on">
            <span class="grey--text pr-1">Filter By Project: </span> {{ contextProjectFilter }}
            <v-icon>arrow_drop_down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in ['All', 'Project A', 'Project B']"
            :key="index"
            @click="contextProjectFilter = item"
          >
            <v-list-item-title>{{ item }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu> -->
    </v-row>
    <v-divider class="my-2"></v-divider>
    <v-row>
      <v-col cols="4">
        <v-card class="px-8 py-4 " outlined>
          <context-list-drop-helper status="current"></context-list-drop-helper>
          <h3 class="headline mb-2">Current</h3>
          <template v-for="project in currentContexts.projects">
            <v-list-item dense :key="project.name" exact :to="{ name: 'project' }">
              <v-list-item-subtitle>{{ project.name }} </v-list-item-subtitle>
            </v-list-item>
            <context-list-item
              v-for="context in project.contexts"
              :key="context.id"
              :context="context"
              iconColor="blue lighten-1"
            ></context-list-item>
            <v-divider class="mb-3" :key="'divider' + project.name"></v-divider>
          </template>
          <context-list-item
            v-for="context in currentContexts.other"
            :key="context.id"
            :context="context"
            iconColor="blue lighten-1"
          ></context-list-item>
          <!-- <v-btn text><v-icon>add</v-icon> New Context</v-btn> -->
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="px-8 py-4" outlined>
          <context-list-drop-helper status="later"></context-list-drop-helper>
          <h3 class="headline mb-2">Later</h3>
          <template v-for="project in futureContexts.projects">
            <v-list-item dense :key="project.name" exact :to="{ name: 'project' }">
              <v-list-item-subtitle>{{ project.name }} </v-list-item-subtitle>
            </v-list-item>
            <context-list-item
              v-for="context in project.contexts"
              :key="context.id"
              :context="context"
            ></context-list-item>
            <v-divider class="mb-3" :key="'divider' + project.name"></v-divider>
          </template>
          <context-list-item
            v-for="context in futureContexts.other"
            :key="context.id"
            :context="context"
          ></context-list-item>
          <!-- <v-btn text><v-icon>add</v-icon> New Context</v-btn> -->
        </v-card>
      </v-col>
      <v-col cols="3" style="opacity: 0.8">
        <v-card class="px-8 py-4" color="" outlined>
          <context-list-drop-helper status="completed"></context-list-drop-helper>
          <h3 class="headline mb-2">Completed</h3>
          <context-list-item
            v-for="context in completedContexts"
            :key="context.id"
            :context="context"
          ></context-list-item>
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import ContextListItem from './ContextListItem';
import ContextListDropHelper from './ContextListDropHelper';

export default {
  components: { ContextListItem, ContextListDropHelper },
  data() {
    return {
      workspace: {
        logo:
          'https://icons-for-free.com/iconfiles/png/512/duckduckgo+engine+internet+optimization+search+web+icon-1320192725018157061.png',
        name: 'DuckDuckGo'
      },
      contextProjectFilter: 'All'
    };
  },
  computed: {
    // ...mapGetters('userWorkspaceLite', ['userWorkspaceLites', 'workspaceContexts']),
    ...mapGetters('workspaces', ['workspaceContexts']),
    filteredContexts() {
      return this.contextProjectFilter == 'All'
        ? this.workspaceContexts
        : this.workspaceContexts.filter(c => this.contextProjectFilter == c.project);
    },
    currentContexts() {
      const contexts = this.filteredContexts.filter(
        d => d.type == 'context' && d.userStatus == 'current'
      );
      const projects = {};
      const other = [];
      contexts.forEach(c => {
        if (c.project) {
          if (projects[c.project]) {
            projects[c.project].contexts.push(c);
          } else {
            projects[c.project] = { name: c.project, contexts: [c] };
          }
        } else {
          other.push(c);
        }
      });
      return { projects, other };
    },
    futureContexts() {
      const contexts = this.filteredContexts.filter(
        d => d.type == 'context' && d.userStatus == 'later'
      );
      const projects = {};
      const other = [];
      contexts.forEach(c => {
        if (c.project) {
          if (projects[c.project]) {
            projects[c.project].contexts.push(c);
          } else {
            projects[c.project] = { name: c.project, contexts: [c] };
          }
        } else {
          other.push(c);
        }
      });
      return { projects, other };
    },
    completedContexts() {
      return this.filteredContexts.filter(d => d.type == 'context' && d.userStatus == 'completed');
    }
  }
};
</script>

<style></style>
